/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { GET_VIDEO_TASK_COMPLETION_STATUS , VIDEO_TASK_COMPLETION_STATUS_RESPONSE} = constants.GetVideoTaskStatusConstants;

export default {
    GET_VIDEO_TASK_COMPLETION_STATUS,
    VIDEO_TASK_COMPLETION_STATUS_RESPONSE,

  requestVideoTaskStatusData: payload => ({
    type: GET_VIDEO_TASK_COMPLETION_STATUS,
    payload
  }),
  videoTaskDataReceived: () => ({
    type: VIDEO_TASK_COMPLETION_STATUS_RESPONSE
  }),
};
